<template>
  <div>
    <el-popover
      placement="bottom"
      width="300"
      @after-leave="hideChooseDialog"
      :disabled="disabled"
      v-model="visible"
    >
      <div class="address-content-box">
        <div class="address-title">
          {{ selectTitleText }}
          <template v-if="multiple && addressSelected.length">
            ，已选择
            <span class="primary">{{ addressSelected.length }}</span
            >个
          </template>
          <div class="address-title-r">
            <span
              class="address-title-btn primary cur"
              v-if="showCleanBtn"
              @click="cleanChooseDialog"
              >清除</span
            >
            <span
              class="address-title-btn primary cur"
              v-if="showCloseBtn"
              @click="hideChooseDialog"
              >关闭</span
            >
          </div>
        </div>
        <el-tabs v-model="activeName">
          <el-tab-pane label="省" name="province">
            <div class="address-content">
              <span
                class="address-text"
                :class="{ active: item.active }"
                v-for="(item, index) in provinceList"
                :key="index"
                @click="chooseProvince(item, index)"
                >{{ item.label }}</span
              >
            </div>
          </el-tab-pane>
          <el-tab-pane label="市" name="city" :disabled="cityDisabled">
            <div class="address-content">
              <span
                class="address-text"
                :class="{ active: item.active }"
                v-for="(item, index) in cityList"
                :key="index"
                @click="chooseCity(item, index)"
                >{{ item.label }}</span
              >
            </div>
          </el-tab-pane>
          <el-tab-pane
            label="区/县"
            name="district"
            :disabled="selectType === 2 || !addressSelected[1]"
          >
            <div class="address-content">
              <span
                class="address-text"
                :class="{ active: item.active }"
                v-for="(item, index) in districtList"
                :key="index"
                @click="chooseDistrict(item, index)"
                >{{ item.label }}</span
              >
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div
        class="chooseShowBox posire cur"
        :class="{ active: Boolean(addressName), disabled: disabled }"
        :style="{ width: valueWidth || 'auto' }"
        @click="showChooseDialog"
        slot="reference"
        :title="addressName || ''"
      >
        {{ addressName || placeholder || '请选择' }}
        <span
          v-if="addressSelected.length && !disabled"
          class="clean primary cur"
          @click="cleanChooseDialog"
          >清除</span
        >
      </div>
    </el-popover>
  </div>
</template>

<script>
import { getProvinces, getCitys, getCountry } from 'api';
import {
  findAddressName,
} from '@qx/utils';
export default {
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'change',
  },
  props: {
    resultVal: {
      default: () => ([]),
    },
    // 是否多选
    multiple: {
      type: Boolean,
      default: false,
    },
    // 最多可选多少个
    multipleAmount: {
      type: Number,
      default: 3,
    },
    valueWidth: {
      type: String,
      default: '',
    },
    // 请求接口获取地址的类型，有一个值是 pingan 的
    addressType: {
      type: String,
      default: '',
    },
    // 选择省市区 还是 省市，1：省市区、2：省市
    selectType: {
      type: Number,
      default: 1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showCloseBtn: {
      type: Boolean,
      default: false,
    },
    showCleanBtn: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
  },
  watch: {
    resultVal: {
      immediate: true,
      async handler (newValue, oldValue) {
        if (newValue) {
          if (newValue.length) {
            if (this.multiple) {
              let addressNameList = [];
              for (let item of newValue) {
                const resProvince = await getProvinces({
                  type: this.addressType,
                });
                const provinceName = (resProvince.find((info) => info.value === item[0])).label;
                const resCity = await getCitys({
                  provicesId: item[0],
                  type: this.addressType,
                });
                const cityName = (resCity.find((info) => info.value === item[1])).label;

                let tempAddressName = '';
                if (this.selectType === 1) {
                  // 省市区
                  const resDistrict = await getCountry({
                    cityId: item[2],
                    type: this.addressType,
                  });
                  const districtName = (resDistrict.find((info) => info.value === item[2])).label;
                  tempAddressName = `${provinceName} / ${cityName} / ${districtName}`;
                } else {
                  // 省市
                  tempAddressName = `${provinceName} / ${cityName}`;
                }
                addressNameList.push(tempAddressName);
              }
              // 显示选中的地方
              this.addressName = addressNameList.join('，');
              this.addressSelected = newValue;

              // 重置一下选中状态
              this.setActive('provinceList');
              this.setActive('cityList');
              this.setActive('districtList');
              // 高亮显示选择状态
              for (let activeItem of this.addressSelected) {
                if (activeItem) {
                  if (activeItem[0]) {
                    this.setActive('provinceList', activeItem[0], false);
                  }
                  if (activeItem[1]) {
                    this.setActive('cityList', activeItem[1], false);
                  }
                  if (activeItem[2]) {
                    this.setActive('districtList', activeItem[2], false);
                  }
                }
              }
              this.$emit('chooseChange', this.addressSelected);
            } else {
              let addressName = '';
              await this.getProvincesInfo();
              this.setActive('provinceList', newValue[0]);
              await this.getCityInfo({ value: newValue[0] });
              this.setActive('cityList', newValue[1]);
              // 根据传进来的 省市区id 反查对应的名称
              const addressNameList = await findAddressName({
                arr: newValue,
                type: this.addressType,
              });
              if (this.selectType === 1) {
                // 省市区
                await this.getDistrictInfo({ value: newValue[1] });
                this.setActive('districtList', newValue[2]);
                addressName = `${addressNameList[0]} / ${addressNameList[1]} / ${addressNameList[2]}`;
              } else {
                // 省市
                addressName = `${addressNameList[0]} / ${addressNameList[1]}`;
              }
              this.addressName = addressName;
              this.addressSelected = newValue;
            }
          } else {
            this.cleanChooseDialog(false);
          }
        } else {
          this.cleanChooseDialog(false);
        }
      },
    },
  },
  computed: {
    selectTitleText () {
      let text = '您的筛选条件：';
      if (this.multiple) {
        let selectName = '城市';
        if (this.selectType === 1) {
          selectName = '区/县';
        }
        text = `最多可选${this.multipleAmount}个${selectName}`;
      }
      return text;
    },
    cityDisabled () {
      let disabled = false;
      if (this.multiple) {
        if (!this.currentSelectProvinceId) {
          disabled = true;
        }
      } else {
        if (!this.addressSelected[0]) {
          disabled = true;
        }
      }
      return disabled;
    },
  },
  data () {
    return {
      // 显示的地址全称
      addressName: '',
      // 是否显示地址选择器
      visible: false,
      // 当前选择的 tab name
      activeName: 'province',
      // 已选择的地址省市区id [省id,市id,区id]
      addressSelected: [],
      // 省列表
      provinceList: [],
      // 市列表
      cityList: [],
      // 区列表
      districtList: [],
      // 当前选择的省份
      currentSelectProvinceId: null,
      // 当前选择的城市
      currentSelectCityId: null,
    };
  },
  methods: {
    // 设置高亮
    async setActive (listName, activeId = null, isResetActive = true) {
      for (let i = 0; i < this[listName].length; i++) {
        if (isResetActive) {
          this[listName][i].active = false;
        }
        if (this[listName][i].value === activeId) {
          this.$set(this[listName][i], 'active', true);
        }
      }
    },
    // 点击地址选择器
    async showChooseDialog () {
      if (this.disabled) {
        return;
      }
      // 切换成第一个 tab，获取省份信息
      this.activeName = 'province';
      await this.getProvincesInfo();
    },
    // 清空选择
    cleanChooseDialog (isSetVal = true) {
      this.addressName = '';
      this.addressSelected = [];
      this.setActive('provinceList');
      this.setActive('cityList');
      this.setActive('districtList');
      this.currentSelectProvinceId = null;
      this.currentSelectCityId = null;
      isSetVal && this.choose();
    },
    // 隐藏选择
    hideChooseDialog () {
      if (this.multiple) {
        if (this.selectType === 1) {
          // 还要选择区
          // 省市，如果没有选够1个的省市区，清空数据
          if (!(this.addressSelected.length && this.addressSelected[0].length === 3)) {
            this.cleanChooseDialog(false);
          }
        } else {
          // 省市，如果没有选够1个的省市，清空数据
          if (!(this.addressSelected.length && this.addressSelected[0].length === 2)) {
            this.cleanChooseDialog(false);
          }
        }
      } else {
        if (this.selectType === 1) {
          // 省市区，如果没有选择够省市区，关闭之后则清空选择
          if (this.addressSelected.length < 3) {
            this.cleanChooseDialog(false);
          }
        } else {
          // 省市
          if (this.addressSelected.length < 2) {
            this.cleanChooseDialog(false);
          }
        }
      }
      this.choose();
      this.visible = false;
    },
    // 抛出地址信息供外部使用，格式：[省id,市id,区id]
    choose (isResetToProvince = true) {
      this.$emit('cc', this.addressSelected);
      this.$emit('change', this.addressSelected);
      if (isResetToProvince) {
        this.activeName = 'province';
      }
    },
    // 获取省列表
    async getProvincesInfo () {
      if (!this.provinceList.length) {
        const res = await getProvinces({
          type: this.addressType,
        });
        this.provinceList = res;
        this.setActive('provinceList');
        // 高亮显示选择状态
        for (let activeItem of this.addressSelected) {
          if (activeItem) {
            if (activeItem[0]) {
              this.setActive('provinceList', activeItem[0], false);
            }
          }
        }
      }

    },
    // 获取城市列表
    async getCityInfo (item) {
      const res = await getCitys({
        provicesId: item.value,
        type: this.addressType,
      });
      this.cityList = res;
    },
    // 获取区列表
    async getDistrictInfo (item) {
      const res = await getCountry({
        cityId: item.value,
        type: this.addressType,
      });
      this.districtList = res;
    },
    // 点击省份
    async chooseProvince (item, index) {
      if (this.multiple) {
        // 多选

        // 记录当前选择的省份
        this.currentSelectProvinceId = item.value;
        await this.getCityInfo(item);
        this.setActive('cityList');
        // 高亮显示选择状态
        for (let activeItem of this.addressSelected) {
          if (activeItem) {
            if (activeItem[1]) {
              this.setActive('cityList', activeItem[1], false);
            }
          }
        }
      } else {
        // 单选

        // 如果重新选择省份，先清空之前的选择
        this.addressSelected = [];
        this.cityList = [];
        this.districtList = [];
        this.addressName = '';
        this.$set(this.addressSelected, 0, item.value);
        await this.getCityInfo(item);
      }
      this.activeName = 'city';
    },
    // 点击城市
    chooseCity (item, index) {
      if (this.multiple) {
        if (this.selectType === 1) {
          // 还要选择区

          // 果断 TODO
        } else {
          // 只需要选择省市
          this.currentSelectCityId = item.value;
          let isFoundInSelected = this.addressSelected.find((item) =>
            item && (item[0] === this.currentSelectProvinceId) && (item[1] === this.currentSelectCityId)
          );
          if (isFoundInSelected) {
            // 反选删除
            const foundIndex = this.addressSelected.findIndex((item) =>
              item && (item[0] === this.currentSelectProvinceId) && (item[1] === this.currentSelectCityId)
            );
            this.addressSelected.splice(foundIndex, 1);
          } else {
            if (this.addressSelected.length < this.multipleAmount) {
              // 选中，放进数组里面
              this.addressSelected.push([this.currentSelectProvinceId, this.currentSelectCityId]);
            }
          }
          this.choose(false);
        }
      } else {
        this.$set(this.addressSelected, 1, item.value);
        if (this.selectType === 1) {
          // 选择区
          this.activeName = 'district';
          this.getDistrictInfo(item);
        } else {
          // 选择省市
          this.visible = false;
          // 抛出选择
          this.choose();
        }
      }
    },
    // 点击县/区域
    chooseDistrict (item, index) {
      this.$set(this.addressSelected, 2, item.value);
      this.visible = false;
      // 抛出信息
      this.choose();
    },
  },
};
</script>

<style scoped lang="scss">
.chooseShowBox {
  height: 32px;
  line-height: 32px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  padding: 0 15px;
  border-radius: 4px;
  color: #c0c4cc;
  outline: none;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  .downIcon {
    font-size: 14px;
    right: 5px;
    top: 8px;
    color: #c0c4cc;
  }
  .clean {
    float: right;
    display: none;
  }
  &:hover {
    .clean {
      display: block;
    }
  }
  &.active {
    color: #333;
  }
  &.disabled {
    color: #c0c4cc !important;
    background-color: #f5f7fa !important;
    cursor: not-allowed;
  }
}
.address-content-box {
  .address-title {
    .address-title-r {
      float: right;
      .address-title-btn {
        display: inline-block;
        margin-right: 10px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .address-content {
    margin-right: -12px;
    .address-text {
      margin-right: 10px;
      margin-bottom: 4px;
      padding: 2px 4px;
      display: inline-block;
      cursor: pointer;
      &:hover {
        background-color: #cccccc;
        color: #ffffff;
      }
      &.active {
        background-color: #69c0ff;
        color: #ffffff;
      }
    }
  }
}
</style>
